<app-ias-loader *ngIf="loading"></app-ias-loader>
<div class="toast-container position-fixed top-0 end-0 p-3">
  <div id="liveToast" class="toast align-items-center text-bg-{{ toastType }} border-0" role="alert"
    aria-live="assertive" aria-atomic="true">
    <div class="d-flex">
      <div class="toast-body">
        {{ toastMessage }}
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
        aria-label="Close"></button>
    </div>
  </div>
</div>
<div class="modal fade" id="uploadModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-3">
      <div class="modal-header">
        <h5 class="modal-title">Upload & Crop Image</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        <input type="file" accept="image/*" (change)="onFileChange($event)" class="form-control mb-3" />

        <image-cropper *ngIf="imageChangedEvent" [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
          [aspectRatio]="1/1" [resizeToWidth]="200" [roundCropper]="true" format="png"
          (imageCropped)="imageCropped($event)" [backgroundColor]="'rgba(0,0,0,0.6)'">
        </image-cropper>
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <button class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button class="btn btn-dark" (click)="cropImage()" [disabled]="!croppedImage">Crop</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<!-- <div class="modal fade" id="Warning" tabindex="-1" aria-labelledby="WarningLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-4 text-center">
      <div class="modal-body">
        <h5 class="mb-3"><svg xmlns="http://www.w3.org/2000/svg" width="44" height="43" viewBox="0 0 44 43" fill="none">
            <mask id="mask0_51050_5200" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="44"
              height="43">
              <rect x="0.5" width="43" height="43" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_51050_5200)">
              <path
                d="M22.0002 30.4584C22.5078 30.4584 22.9333 30.2867 23.2767 29.9433C23.6201 29.5999 23.7918 29.1743 23.7918 28.6667C23.7918 28.1591 23.6201 27.7335 23.2767 27.3901C22.9333 27.0467 22.5078 26.875 22.0002 26.875C21.4925 26.875 21.067 27.0467 20.7236 27.3901C20.3802 27.7335 20.2085 28.1591 20.2085 28.6667C20.2085 29.1743 20.3802 29.5999 20.7236 29.9433C21.067 30.2867 21.4925 30.4584 22.0002 30.4584ZM20.2085 23.2917H23.7918V12.5417H20.2085V23.2917ZM22.0002 39.4167C19.5217 39.4167 17.1925 38.9464 15.0127 38.0058C12.8328 37.0651 10.9366 35.7886 9.32412 34.1761C7.71162 32.5636 6.43506 30.6674 5.49443 28.4875C4.55381 26.3077 4.0835 23.9785 4.0835 21.5C4.0835 19.0216 4.55381 16.6924 5.49443 14.5125C6.43506 12.3327 7.71162 10.4365 9.32412 8.824C10.9366 7.2115 12.8328 5.93494 15.0127 4.99431C17.1925 4.05369 19.5217 3.58337 22.0002 3.58337C24.4786 3.58337 26.8078 4.05369 28.9877 4.99431C31.1675 5.93494 33.0637 7.2115 34.6762 8.824C36.2887 10.4365 37.5653 12.3327 38.5059 14.5125C39.4465 16.6924 39.9168 19.0216 39.9168 21.5C39.9168 23.9785 39.4465 26.3077 38.5059 28.4875C37.5653 30.6674 36.2887 32.5636 34.6762 34.1761C33.0637 35.7886 31.1675 37.0651 28.9877 38.0058C26.8078 38.9464 24.4786 39.4167 22.0002 39.4167ZM22.0002 35.8334C26.0016 35.8334 29.3908 34.4448 32.1679 31.6677C34.945 28.8907 36.3335 25.5014 36.3335 21.5C36.3335 17.4987 34.945 14.1094 32.1679 11.3323C29.3908 8.55525 26.0016 7.16671 22.0002 7.16671C17.9988 7.16671 14.6095 8.55525 11.8325 11.3323C9.05537 14.1094 7.66683 17.4987 7.66683 21.5C7.66683 25.5014 9.05537 28.8907 11.8325 31.6677C14.6095 34.4448 17.9988 35.8334 22.0002 35.8334Z"
                fill="#C82F2F" />
            </g>
          </svg> Impersonation Warning</h5>
        <h6 class="mb-2">
          Impersonating an IAS officer or providing false information to obtain IAS Association membership is a criminal
          offence under:
        </h6>
        <p>
          Section 170 of the Indian Penal Code (IPC) - Personating a public servant
        </p>
      </div>
      <button type="button" class="btn login-btn w-75 mx-auto mb-4" data-bs-dismiss="modal">Continue</button>
    </div>
  </div>
</div> -->


<div class="main-login-component d-flex align-items-center">
  <div class="intro-image-div position-relative" [routerLink]="''">
  </div>
  <div class="login-form-div d-flex flex-column align-items-center px-5">

    <!-- Step 1: Email -->
    <div *ngIf="currentStep === 1" class="stepcontainer">
      <h1 class="mb-4">Create Account</h1>
      <form [formGroup]="emailForm" (ngSubmit)="submitEmail()">
        <label for="email">Email ID or Mobile Number</label>
        <input type="text" class="mb-1" id="email" formControlName="email"
          placeholder="Enter Valid Email Id or Mobile Number" />
        <div *ngIf="emailForm.get('email')?.touched && emailForm.get('email')?.invalid" class="error-message">
          <small *ngIf="emailForm.get('email')?.errors?.['required']">
            Email or mobile number is required.
          </small>

          <small *ngIf="emailForm.get('email')?.errors?.['invalidContact']">
            Enter a valid email or mobile number.
          </small>
        </div>
        <button class="login-btn my-4" type="submit" [disabled]="emailForm.invalid">Sign up</button>

        <!-- <div class="d-flex align-items-center mb-3 w-100">
          <hr class="flex-grow-1">
          <span class="mx-2 text-muted fw-bold">Or</span>
          <hr class="flex-grow-1">
        </div> -->
        
        <!-- <button class="login-btn w-100 mb-4 bg-white text-dark border border-secondary d-flex justify-content-center align-items-center gap-2" type="button" (click)="signupWithGoogle()">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
            <path fill="#FFC107"
              d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z">
            </path>
            <path fill="#FF3D00"
              d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z">
            </path>
            <path fill="#4CAF50"
              d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z">
            </path>
            <path fill="#1976D2"
              d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z">
            </path>
          </svg>
          Continue with Google
        </button> -->

        <div class="warning-box">
          <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M7.3335 11.3333H8.66683V7.33331H7.3335V11.3333ZM8.00016 5.99998C8.18905 5.99998 8.34738 5.93609 8.47516 5.80831C8.60294 5.68053 8.66683 5.5222 8.66683 5.33331C8.66683 5.14442 8.60294 4.98609 8.47516 4.85831C8.34738 4.73054 8.18905 4.66665 8.00016 4.66665C7.81127 4.66665 7.65294 4.73054 7.52516 4.85831C7.39738 4.98609 7.3335 5.14442 7.3335 5.33331C7.3335 5.5222 7.39738 5.68053 7.52516 5.80831C7.65294 5.93609 7.81127 5.99998 8.00016 5.99998ZM8.00016 14.6666C7.07794 14.6666 6.21127 14.4916 5.40016 14.1416C4.58905 13.7916 3.8835 13.3166 3.2835 12.7166C2.6835 12.1166 2.2085 11.4111 1.8585 10.6C1.5085 9.78887 1.3335 8.9222 1.3335 7.99998C1.3335 7.07776 1.5085 6.21109 1.8585 5.39998C2.2085 4.58887 2.6835 3.88331 3.2835 3.28331C3.8835 2.68331 4.58905 2.20831 5.40016 1.85831C6.21127 1.50831 7.07794 1.33331 8.00016 1.33331C8.92238 1.33331 9.78905 1.50831 10.6002 1.85831C11.4113 2.20831 12.1168 2.68331 12.7168 3.28331C13.3168 3.88331 13.7918 4.58887 14.1418 5.39998C14.4918 6.21109 14.6668 7.07776 14.6668 7.99998C14.6668 8.9222 14.4918 9.78887 14.1418 10.6C13.7918 11.4111 13.3168 12.1166 12.7168 12.7166C12.1168 13.3166 11.4113 13.7916 10.6002 14.1416C9.78905 14.4916 8.92238 14.6666 8.00016 14.6666ZM8.00016 13.3333C9.48905 13.3333 10.7502 12.8166 11.7835 11.7833C12.8168 10.75 13.3335 9.48887 13.3335 7.99998C13.3335 6.51109 12.8168 5.24998 11.7835 4.21665C10.7502 3.18331 9.48905 2.66665 8.00016 2.66665C6.51127 2.66665 5.25016 3.18331 4.21683 4.21665C3.1835 5.24998 2.66683 6.51109 2.66683 7.99998C2.66683 9.48887 3.1835 10.75 4.21683 11.7833C5.25016 12.8166 6.51127 13.3333 8.00016 13.3333Z"
                fill="#A16800" />
            </svg></span>
          <p>
            This facility is strictly for serving and retired IAS officers only.
            Unauthorized access is prohibited.
          </p>
        </div>
      </form>
    </div>

    <!-- Step 2: OTP -->
    <div *ngIf="currentStep === 2" class="stepcontainer">
      <h1>Enter OTP to Verify</h1>
      <h4>OTP has been sent to your registered email ID- {{ emailForm.value.email }}</h4>
      <form [formGroup]="otpForm" (ngSubmit)="submitOtp()">
        <div class="otp-inputs">
          <input *ngFor="let ctrl of otpControls; let i = index" type="text" maxlength="1" [formControlName]="ctrl"
            (input)="onOtpInput($event, i)" (keydown)="handleKeyDown($event, i)" autocomplete="off" />
        </div>
        <button class="login-btn" type="submit" [disabled]="otpForm.invalid">Continue</button>

        <span class="d-flex align-items-center gap-2 mt-2">
          <p class="m-0">Did not get the OTP?</p><span class="resend-text" (click)="!isResendDisabled && onResendOtp()"
            [class.disabled]="isResendDisabled">
            Resend OTP
          </span> in <span class="timer m-0"> {{ countdown * 1000 | date:'mm:ss':'UTC' }}</span>
        </span>
      </form>
    </div>
    <div *ngIf="currentStep === 3" class="stepcontainer">
      <h1 class="mb-4">Sign up your account</h1>
      <button class="login-btn mt-4" type="submit" (click)="currentStep = 4">Get Details from DoPT</button>
      <p class="text-center my-3">or</p>
      <button class="white-btn" type="button" (click)="currentStep = 5">Fill Details Manually</button>
      <p class="text-center my-3">or</p>
      <button class="white-btn" type="button" (click)="currentStep = 6">Retired Member Signup</button>
    </div>
    <!-- auto  form  -->
    <div *ngIf="currentStep === 4" class="stepcontainer">
      <p><span class="cursor-pointer fs-5 fw-bold" (click)="currentStep = 3"><i class="fas fa-arrow-left"></i>
          back</span>
      </p>
      <h1 class="mb-4">Get Details from DoPT</h1>
      <form [formGroup]="memberidForm" (ngSubmit)="submitMemberId()">
        <label for="name">Full Name<span class="redstar">*</span></label>
        <input type="text" id="name" formControlName="name" maxlength="80" placeholder="Enter Your Name"
          (keypress)="allowOnlyLetters($event)" />

        <div *ngIf=" memberidForm.get('name')?.invalid" class="error-message">
          <small *ngIf="memberidForm.get('name')?.errors?.['pattern']">
            Only letters are allowed.
          </small>
        </div>
        <label class="mt-3" for="identityNumber">Identity No.<span class="redstar">*</span></label>
        <input type="text" id="identityNumber" formControlName="identityNumber" placeholder="Enter Your Identity No." />
        <div *ngIf="memberidForm.get('identityNumber')?.touched &&  memberidForm.get('identityNumber')?.invalid"
          class="error-message">
          <small *ngIf="memberidForm.get('identityNumber')?.errors?.['required']">
            Identity Number is required.
          </small>
        </div>
        <div class="row">
          <!-- MOBILE FIELD -->
          <div class="col-md-6" *ngIf="contactType === 'email'">
            <label class="mt-3">
              Mobile Number <span class="redstar">*</span>
            </label>

            <input type="text" formControlName="mobilenumber" placeholder="Enter Mobile Number" maxlength="10" />

            <div *ngIf="memberidForm.get('mobilenumber')?.touched &&
              memberidForm.get('mobilenumber')?.invalid" class="error-message">

              <small *ngIf="memberidForm.get('mobilenumber')?.errors?.['required']">
                Mobile number required
              </small>

              <small *ngIf="memberidForm.get('mobilenumber')?.errors?.['pattern']">
                Enter valid mobile number
              </small>
            </div>
          </div>

          <!-- EMAIL FIELD -->
          <div class="col-md-6" *ngIf="contactType === 'mobile'">
            <label class="mt-3">
              Email ID <span class="redstar">*</span>
            </label>

            <input type="email" formControlName="email" placeholder="Enter Email ID" />

            <div *ngIf="memberidForm.get('email')?.touched &&
              memberidForm.get('email')?.invalid" class="error-message">

              <small *ngIf="memberidForm.get('email')?.errors?.['required']">
                Email required
              </small>

              <small *ngIf="memberidForm.get('email')?.errors?.['pattern']">
                Enter valid email
              </small>
            </div>
          </div>

          <div class="col-md-6">

            <label for="alternateEmail" class="mt-3">Alternate Email ID </label>
            <input type="email" id="alternateEmail" formControlName="alternateEmail" placeholder="Enter Email ID"
              maxlength="100" />
            <div *ngIf="memberidForm.get('alternateEmail')?.touched &&  memberidForm.get('alternateEmail')?.invalid"
              class="error-message">
              <small *ngIf="memberidForm.get('alternateEmail')?.errors?.['pattern']">
                Enter a valid email
              </small>
            </div>
          </div>

        </div>
        <button class="login-btn my-3 mt-4" type="submit" [disabled]="memberidForm.invalid">Continue</button>
      </form>
    </div>

    <!-- memberformmm -->
    <div *ngIf="currentStep === 5" class="stepcontainer">
      <p><span class="cursor-pointer fs-5 fw-bold" (click)="currentStep = 3"><i class="fas fa-arrow-left"></i>
          back</span>
      </p>
      <h1 class="mb-4">Fill Your Details Manually</h1>
      <form [formGroup]="memberdetailsForm" (ngSubmit)="submitmemberdetails()">
        <label for="FullName">Full Name<span class="redstar">*</span></label>
        <input type="text" id="FullName" formControlName="fullname" maxlength="80" placeholder="Enter Your Name"
          (keypress)="allowOnlyLetters($event)" />

        <div class="row mt-3">
          <div class="col-md-6">
            <label for="Cadre">Cadre<span class="redstar">*</span></label>
            <select class="form-select" id="Cadre" aria-label="Default select example" formControlName="cadre">
              <option value="0" disabled>Enter Cadre</option>
              @for( cadre of cadrelist; track $index) {
              <option [value]="cadre.id">{{ cadre.name }}</option>
              }
            </select>
          </div>
          <div class="col-md-6">
            <label for="allotmentyear">Allotment Year<span class="redstar">*</span></label>
            <input type="number" class="mb-3" id="allotmentyear" formControlName="allotmentyear"
              placeholder="Enter Allotment Year" (input)="validateYear($event)" />
          </div>
          <div class="col-md-6">
            <label for="Gender">Gender<span class="redstar">*</span></label>
            <select class="form-select" id="Gender" formControlName="gender">
              <option value="" disabled>Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="">Other</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="dob">Date of Birth<span class="redstar">*</span></label>
            <input type="date" class="mb-3" id="dob" formControlName="dateofbirth" placeholder="Select Date of Birth"
              [max]="maxDOB" />
          </div>
          <div class="col-md-6">
            <label for="mothertongue">Mother Tongue<span class="redstar">*</span></label>
            <input type="text" class="mb-3" id="mothertongue" formControlName="mothertongue"
              placeholder="Enter Language" maxlength="40" (keypress)="allowOnlyLetters($event)" />
          </div>
          <div class="col-md-6">
            <label for="retirementreason">Service Status<span class="redstar">*</span></label>
            <select class="form-select" id="retirementreason" formControlName="retirementreason">
              <option value="" disabled>Select Status</option>
              <option value="Serving">Serving</option>
              <option value="Superannuated">Superannuated</option>
            </select>
          </div>
          <div class="col-md-6" *ngIf="contactType === 'email'">
  <label>Mobile Number <span class="redstar">*</span></label>

  <input
    type="text"
    formControlName="mobilenumber"
    maxlength="10"
    placeholder="Enter Your Number"
  />

  <div *ngIf="memberdetailsForm.get('mobilenumber')?.touched &&
              memberdetailsForm.get('mobilenumber')?.invalid"
       class="error-message">

    <small *ngIf="memberdetailsForm.get('mobilenumber')?.errors?.['required']">
      Mobile required
    </small>

    <small *ngIf="memberdetailsForm.get('mobilenumber')?.errors?.['pattern']">
      Enter valid mobile number
    </small>
  </div>
</div>
<div class="col-md-6" *ngIf="contactType === 'mobile'">
  <label>Email ID <span class="redstar">*</span></label>

  <input
    type="email"
    formControlName="email"
    placeholder="Enter Email ID"
  />

  <div *ngIf="memberdetailsForm.get('email')?.touched &&
              memberdetailsForm.get('email')?.invalid"
       class="error-message">

    <small *ngIf="memberdetailsForm.get('email')?.errors?.['required']">
      Email required
    </small>

    <small *ngIf="memberdetailsForm.get('email')?.errors?.['pattern']">
      Enter valid email
    </small>
  </div>
</div>

          <div class="col-md-6">
            <label for="alternateEmail">Alternate Email ID</label>
            <input type="text" class="mb-1" id="alternateEmail" formControlName="alternateEmail"
              placeholder="Enter your Email ID" maxlength="100" />
            <div
              *ngIf="memberdetailsForm.get('alternateEmail')?.touched &&  memberdetailsForm.get('alternateEmail')?.invalid"
              class="error-message">
              <small *ngIf="memberdetailsForm.get('alternateEmail')?.errors?.['pattern']">
                Enter a valid email
              </small>
            </div>
          </div>

        </div>
        <button class="login-btn mt-4" type="submit" [disabled]="memberdetailsForm.invalid">Continue</button>
      </form>
    </div>

    <!-- your details  -->
    <div *ngIf="currentStep === 6" class="stepcontainer">
      <p><span class="cursor-pointer fs-5 fw-bold" (click)="currentStep = 3"><i class="fas fa-arrow-left"></i>
          back</span>
      </p>
      <h1 class="mb-4">Fill Your Details</h1>
      <form [formGroup]="retiredForm" (ngSubmit)="submitRetired()">
        <div class="profile-pic-input mb-3 row">
          <div class="col-md-6">
            <label for="profilePic">Profile Picture <span class="redstar">*</span></label>
            <input type="text" id="profilePic" formControlName="profilePic" placeholder="Click to upload" readonly
              (click)="openModal()" class="form-control cursor-pointer bg-light" />
          </div>
          <div *ngIf="retiredForm.get('profilePic')?.invalid && retiredForm.get('profilePic')?.touched"
            class="error-message">
            <small class="text-danger">Profile picture is required.</small>
          </div>

          <div class="col-md-6">

            <!-- Optional small preview -->
            <div *ngIf="finalImage" class="d-flex align-items-center justify-content-center h-100">
              <img [src]="finalImage" class="rounded-circle border preview-img mt-2" width="80" height="80"
                alt="Preview" />
            </div>
          </div>
        </div>

        <label for="name">Full Name<span class="redstar">*</span></label>
        <input type="text" id="name" formControlName="name" maxlength="80" placeholder="Enter Your Name"
          (keypress)="allowOnlyLetters($event)" />

        <div *ngIf=" retiredForm.get('name')?.invalid" class="error-message">
          <small *ngIf="retiredForm.get('name')?.errors?.['pattern']">
            Only letters are allowed.
          </small>
        </div>
        <label class="mt-3" for="identityNumber">Identity No. <small>(DoPT-allotted ID as shown
            on your ER Sheet)</small></label>
        <input type="text" id="identityNumber" formControlName="identityNumber" maxlength="10"
          placeholder="Enter Your Identity No." />
        <div *ngIf="retiredForm.get('identityNumber')?.touched &&  retiredForm.get('identityNumber')?.invalid"
          class="error-message">
          <div *ngIf="retiredForm.get('identityNumber')?.touched || retiredForm.get('identityNumber')?.dirty"
            class="error-message">
            <small *ngIf="retiredForm.get('identityNumber')?.hasError('required')">
              Identity Number is required.
            </small>
            <small *ngIf="
    retiredForm.get('identityNumber')?.hasError('pattern') ||
    retiredForm.get('identityNumber')?.hasError('minlength') ||
    retiredForm.get('identityNumber')?.hasError('maxlength')
  ">
              Enter a valid Identity Number.
            </small>


          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6">
            <label for="dob">Date of Birth<span class="redstar">*</span></label>
            <input type="date" class="mb-3" id="dob" formControlName="dateofbirth" placeholder="Select Date of Birth"
              [max]="maxDOB" />
          </div>
          <div class="col-md-6">
            <label for="Cadre">Cadre<span class="redstar">*</span></label>
            <select class="form-select" id="Cadre" aria-label="Default select example" formControlName="cadre">
              <option value="0" disabled>Enter Cadre</option>
              @for( cadre of cadrelist; track $index) {
              <option [value]="cadre.id">{{ cadre.name }}</option>
              }
            </select>
          </div>
          <div class="col-md-6">
            <label for="allotmentyear">Allotment Year<span class="redstar">*</span></label>
            <input type="number" class="mb-3" id="allotmentyear" formControlName="allotmentyear"
              placeholder="Enter Allotment Year" (input)="validateYear($event)" />
          </div>

          <div class="col-md-6" *ngIf="contactType === 'email'">
  <label>Mobile Number <span class="redstar">*</span></label>

  <input
    type="text"
    formControlName="mobilenumber"
    maxlength="10"
    placeholder="Enter Your Number"
  />

  <div *ngIf="retiredForm.get('mobilenumber')?.touched &&
              retiredForm.get('mobilenumber')?.invalid"
       class="error-message">

    <small *ngIf="retiredForm.get('mobilenumber')?.errors?.['required']">
      Mobile required
    </small>

    <small *ngIf="retiredForm.get('mobilenumber')?.errors?.['pattern']">
      Enter valid mobile number
    </small>
  </div>
</div>
<div class="col-md-6" *ngIf="contactType === 'mobile'">
  <label>Email ID <span class="redstar">*</span></label>

  <input
    type="email"
    formControlName="email"
    placeholder="Enter Email ID"
  />

  <div *ngIf="retiredForm.get('email')?.touched &&
              retiredForm.get('email')?.invalid"
       class="error-message">

    <small *ngIf="retiredForm.get('email')?.errors?.['required']">
      Email required
    </small>

    <small *ngIf="retiredForm.get('email')?.errors?.['pattern']">
      Enter valid email
    </small>
  </div>
</div>

        </div>
        <button class="login-btn my-3 mt-4" type="submit" [disabled]="retiredForm.invalid">Continue</button>
      </form>
    </div>
    <!-- your details  -->
    <div *ngIf="currentStep === 7" class="stepcontainer">
      <h1 class="mb-4">Your Details</h1>
      <div class="detailscard shadow-sm border rounded-4">
        <div class="d-flex align-items-center">
          <!-- Profile Image -->
          <img *ngIf="iasprofilePic" [src]="iasprofilePic" class="rounded-circle me-4" alt=""
            style="width:80px; height:80px; object-fit:cover; object-position: center;">

          <!-- Details -->
          <div>
            <h3 class="mb-3">{{iasname}}</h3>
            <div class="d-flex flex-wrap gap-2 text-muted">
              <span>IAS Batch Year:<strong> {{iasbatch}}</strong></span>
              <span class="mx-2">|</span>
              <span>Cadre Domicile: <strong>{{iascadre}}</strong></span>
            </div>
          </div>
        </div>
      </div>
      <button class="login-btn mt-4" (click)="submitdetails()">Continue</button>
      <p class="mt-3">Wrong profile or incorrect information? <span class="text-danger cursor-pointer"
          (click)="currentStep = 3"> Retry.</span></p>
    </div>

    <div *ngIf="currentStep === 8" class="stepcontainer">
      <h1 class="mb-4">Create Password</h1>
      <form [formGroup]="passwordForm" (ngSubmit)="submitPassword()">
        <label for="newPassword">Create Password</label>
        <div class="password-wrapper my-1">
          <input [type]="showNewPassword ? 'text' : 'password'" id="newPassword" formControlName="newPassword" />
          <button type="button" class="eye-btn" (click)="togglePassword('new')">
            <svg *ngIf="!showNewPassword" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"
              fill="none">
              <g clip-path="url(#clip0_50828_258)">
                <path
                  d="M9.49996 4.75002C12.5004 4.75002 15.1762 6.43627 16.4825 9.10419C15.1762 11.7721 12.5004 13.4584 9.49996 13.4584C6.49954 13.4584 3.82371 11.7721 2.51746 9.10419C3.82371 6.43627 6.49954 4.75002 9.49996 4.75002ZM9.49996 3.16669C5.54163 3.16669 2.16121 5.62877 0.791626 9.10419C2.16121 12.5796 5.54163 15.0417 9.49996 15.0417C13.4583 15.0417 16.8387 12.5796 18.2083 9.10419C16.8387 5.62877 13.4583 3.16669 9.49996 3.16669ZM9.49996 7.12502C10.5925 7.12502 11.4791 8.01169 11.4791 9.10419C11.4791 10.1967 10.5925 11.0834 9.49996 11.0834C8.40746 11.0834 7.52079 10.1967 7.52079 9.10419C7.52079 8.01169 8.40746 7.12502 9.49996 7.12502ZM9.49996 5.54169C7.53663 5.54169 5.93746 7.14085 5.93746 9.10419C5.93746 11.0675 7.53663 12.6667 9.49996 12.6667C11.4633 12.6667 13.0625 11.0675 13.0625 9.10419C13.0625 7.14085 11.4633 5.54169 9.49996 5.54169Z"
                  fill="#A9ACB1" />
              </g>
              <defs>
                <clipPath id="clip0_50828_258">
                  <rect width="19" height="19" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <svg *ngIf="showNewPassword" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"
              fill="none">
              <g clip-path="url(#clip0_50828_300)">
                <path
                  d="M9.50008 4.74999C12.5005 4.74999 15.1763 6.43624 16.4826 9.10416C16.0155 10.07 15.3584 10.9012 14.5747 11.5742L15.6909 12.6904C16.7913 11.7167 17.6622 10.4975 18.2084 9.10416C16.8388 5.62874 13.4584 3.16666 9.50008 3.16666C8.49467 3.16666 7.52883 3.32499 6.61841 3.61791L7.92467 4.92416C8.43925 4.82124 8.96175 4.74999 9.50008 4.74999ZM8.653 5.65249L10.2917 7.29124C10.743 7.48916 11.1072 7.85333 11.3051 8.30458L12.9438 9.94333C13.0072 9.67416 13.0547 9.38916 13.0547 9.09624C13.0626 7.13291 11.4634 5.54166 9.50008 5.54166C9.20717 5.54166 8.93008 5.58124 8.653 5.65249ZM1.59133 3.06374L3.713 5.18541C2.42258 6.19874 1.40133 7.54458 0.791748 9.10416C2.16133 12.5796 5.54175 15.0417 9.50008 15.0417C10.7034 15.0417 11.8592 14.8121 12.9201 14.3925L15.6276 17.1L16.7438 15.9837L2.70758 1.93958L1.59133 3.06374ZM7.52883 9.00124L9.59508 11.0675C9.56342 11.0754 9.53175 11.0833 9.50008 11.0833C8.40758 11.0833 7.52092 10.1967 7.52092 9.10416C7.52092 9.06458 7.52883 9.04083 7.52883 9.00124ZM4.83717 6.30958L6.22258 7.69499C6.0405 8.13041 5.93758 8.60541 5.93758 9.10416C5.93758 11.0675 7.53675 12.6667 9.50008 12.6667C9.99883 12.6667 10.4738 12.5637 10.9013 12.3817L11.6772 13.1575C10.9805 13.3475 10.2522 13.4583 9.50008 13.4583C6.49967 13.4583 3.82383 11.7721 2.51758 9.10416C3.07175 7.97208 3.87925 7.03791 4.83717 6.30958Z"
                  fill="#222222" />
              </g>
              <defs>
                <clipPath id="clip0_50828_300">
                  <rect width="19" height="19" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
        <div *ngIf="passwordForm.get('newPassword')?.touched && passwordForm.get('newPassword')?.hasError('pattern')"
          class="error-message">
          Password must have 8 characters, contain at least one uppercase letter, one lowercase letter, one number, and
          one special
          character.
        </div>
        <label for="confirmPassword" class="mt-3">Confirm Password</label>
        <div class="password-wrapper  my-1">
          <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
            formControlName="confirmPassword" />
          <button type="button" class="eye-btn" (click)="togglePassword('confirm')">
            <svg *ngIf="!showConfirmPassword" xmlns="http://www.w3.org/2000/svg" width="19" height="19"
              viewBox="0 0 19 19" fill="none">
              <g clip-path="url(#clip0_50828_258)">
                <path
                  d="M9.49996 4.75002C12.5004 4.75002 15.1762 6.43627 16.4825 9.10419C15.1762 11.7721 12.5004 13.4584 9.49996 13.4584C6.49954 13.4584 3.82371 11.7721 2.51746 9.10419C3.82371 6.43627 6.49954 4.75002 9.49996 4.75002ZM9.49996 3.16669C5.54163 3.16669 2.16121 5.62877 0.791626 9.10419C2.16121 12.5796 5.54163 15.0417 9.49996 15.0417C13.4583 15.0417 16.8387 12.5796 18.2083 9.10419C16.8387 5.62877 13.4583 3.16669 9.49996 3.16669ZM9.49996 7.12502C10.5925 7.12502 11.4791 8.01169 11.4791 9.10419C11.4791 10.1967 10.5925 11.0834 9.49996 11.0834C8.40746 11.0834 7.52079 10.1967 7.52079 9.10419C7.52079 8.01169 8.40746 7.12502 9.49996 7.12502ZM9.49996 5.54169C7.53663 5.54169 5.93746 7.14085 5.93746 9.10419C5.93746 11.0675 7.53663 12.6667 9.49996 12.6667C11.4633 12.6667 13.0625 11.0675 13.0625 9.10419C13.0625 7.14085 11.4633 5.54169 9.49996 5.54169Z"
                  fill="#A9ACB1" />
              </g>
              <defs>
                <clipPath id="clip0_50828_258">
                  <rect width="19" height="19" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <svg *ngIf="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" width="19" height="19"
              viewBox="0 0 19 19" fill="none">
              <g clip-path="url(#clip0_50828_300)">
                <path
                  d="M9.50008 4.74999C12.5005 4.74999 15.1763 6.43624 16.4826 9.10416C16.0155 10.07 15.3584 10.9012 14.5747 11.5742L15.6909 12.6904C16.7913 11.7167 17.6622 10.4975 18.2084 9.10416C16.8388 5.62874 13.4584 3.16666 9.50008 3.16666C8.49467 3.16666 7.52883 3.32499 6.61841 3.61791L7.92467 4.92416C8.43925 4.82124 8.96175 4.74999 9.50008 4.74999ZM8.653 5.65249L10.2917 7.29124C10.743 7.48916 11.1072 7.85333 11.3051 8.30458L12.9438 9.94333C13.0072 9.67416 13.0547 9.38916 13.0547 9.09624C13.0626 7.13291 11.4634 5.54166 9.50008 5.54166C9.20717 5.54166 8.93008 5.58124 8.653 5.65249ZM1.59133 3.06374L3.713 5.18541C2.42258 6.19874 1.40133 7.54458 0.791748 9.10416C2.16133 12.5796 5.54175 15.0417 9.50008 15.0417C10.7034 15.0417 11.8592 14.8121 12.9201 14.3925L15.6276 17.1L16.7438 15.9837L2.70758 1.93958L1.59133 3.06374ZM7.52883 9.00124L9.59508 11.0675C9.56342 11.0754 9.53175 11.0833 9.50008 11.0833C8.40758 11.0833 7.52092 10.1967 7.52092 9.10416C7.52092 9.06458 7.52883 9.04083 7.52883 9.00124ZM4.83717 6.30958L6.22258 7.69499C6.0405 8.13041 5.93758 8.60541 5.93758 9.10416C5.93758 11.0675 7.53675 12.6667 9.50008 12.6667C9.99883 12.6667 10.4738 12.5637 10.9013 12.3817L11.6772 13.1575C10.9805 13.3475 10.2522 13.4583 9.50008 13.4583C6.49967 13.4583 3.82383 11.7721 2.51758 9.10416C3.07175 7.97208 3.87925 7.03791 4.83717 6.30958Z"
                  fill="#222222" />
              </g>
              <defs>
                <clipPath id="clip0_50828_300">
                  <rect width="19" height="19" fill="white" />
                </clipPath>
              </defs>
            </svg> </button>
        </div>
        <div *ngIf="passwordnotmatch" class="error-message">
          Passwords do not match.
        </div>
        <button class="login-btn mt-4" type="submit">Create password</button>
      </form>
    </div>

    <!-- Step 8: Success -->
    <div *ngIf="currentStep === 9" class="stepcontainer">
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
        <circle cx="50" cy="50" r="50" fill="#4B9700" fill-opacity="0.3" />
        <circle cx="50" cy="50" r="45" fill="#4B9700" fill-opacity="0.3" />
        <circle cx="49.5" cy="49.5" r="39.5" fill="#4B9700" />
        <path d="M30 51.5L40.2267 62.1713C40.9464 62.9223 42.1216 62.9963 42.9298 62.3414L70.5 40" stroke="white"
          stroke-width="5" stroke-linecap="round" />
      </svg>
      <h1 class="mt-3">You have successfully signed up</h1>
      <h4 class="mb-4" *ngIf="!isSso">You can now login using your email and password.</h4>
      <h4 class="mb-4" *ngIf="isSso">You can now continue using your Google Account.</h4>
      <button class="login-btn" type="button" [routerLink]="''">Return to Login</button>
    </div>
  </div>
</div>